module.exports = __webpack_public_path__ + "img/STAMP_STAR_BLANK.c2a6ef58.png";